import { AnimatePresence, motion } from "framer-motion";
import React, { ReactNode } from "react";
import { Question, QuestionContent } from "./QuestionContent";
import { QuestionContentExit } from "./QuestionContentExit";
import { ResultContent } from "./ResultContent";
import { ResultContentExit } from "./ResultContentExit";
import { WelcomeContent } from "./WelcomeContent";
import { WelcomeContentExit } from "./WelcomeContentExit";

export type State = "welcome" | "question" | "result";

export const KlimaContent: React.FC = () => {
  const [currentState, setCurrentState] = React.useState<State>("welcome");
  const [currentQuesNum, setCurrentQuesNum] = React.useState<number>(0);
  const [isFirst, setIsFirst] = React.useState(true);

  const preloadImages = [
    "welcome",
    "airplane",
    "car1",
    "car2",
    "family",
    "food",
    "leisure",
    "equipment",
    "result",
  ];

  preloadImages.map((name) => {
    const img = new Image();
    img.src = `/images/${name}.png`;
    return img;
  });

  const questions: Question[] = [
    {
      text: "食生活は?",
      name: "food",
      image: "/images/food.png",
      options: [
        { text: "お肉が好き", value: 1368 },
        { text: "肉は控えめ", value: 807 },
        { text: "魚と野菜", value: 684 },
        { text: "ベジタリアン", value: 616 },
        { text: "完全菜食主義", value: 356 },
      ],
    },
    {
      text: "自家用車の種類は?",
      name: "carType",
      image: "/images/car1.png",
      options: [
        { text: "持っていない", value: 43.6 },
        { text: "ガソリン", value: 131 },
        { text: "EV", value: 44 },
        { text: "EV（非化石）", value: 1.3 },
      ],
    },
    {
      text: "自家用車の走行距離は?",
      name: "carDistance",
      image: "/images/car2.png",
      options: [
        { text: "年間5,000km", value: 5 },
        { text: "年間10,000km", value: 10 },
        { text: "年間15,000km", value: 15 },
        { text: "年間20,000km", value: 20 },
      ],
    },
    {
      text: "飛行機は?",
      name: "airplaneFrequency",
      image: "/images/airplane.png",
      options: [
        { text: "乗らない", value: 0 },
        { text: "国内移動を年に1回", value: 381 },
        { text: "国内移動を毎月", value: 381 * 12 },
        { text: "海外も行く", value: 2881 * 2 },
      ],
    },
    {
      text: "レジャーの頻度は?",
      name: "leisure",
      image: "/images/leisure.png",
      options: [
        { text: "あまり行かない", value: 904 },
        { text: "普通", value: 1292 },
        { text: "よく行く", value: 1938 },
        { text: "レジャーに本気", value: 3876 },
      ],
    },
    {
      text: "住宅設備のエネルギーは?",
      name: "equipment",
      image: "/images/equipment.png",
      options: [
        { text: "電気 + ガスなど", value: 2432 },
        { text: "オール電化", value: 2043 },
        { text: "太陽光発電", value: 1192 },
        { text: "家庭用燃料電池", value: 389 },
      ],
    },
    {
      text: "同居人の人数は?",
      name: "family",
      image: "/images/family.png",
      options: [
        { text: "自分だけ", value: 1.75 },
        { text: "2人", value: 1.26 },
        { text: "3人", value: 1.0 },
        { text: "4人", value: 0.79 },
        { text: "5人", value: 0.76 },
        { text: "6人以上", value: 0.71 },
      ],
    },
  ];

  return (
    <div className="flex justify-center items-center px-4 max-w-md mx-auto ">
      <AnimatePresence exitBeforeEnter>
        {currentState === "welcome" && (
          <div className="relative w-full">
            <WelcomeContent
              setCurrentState={setCurrentState}
              setIsFirst={setIsFirst}
              isFirst={isFirst}
            />
            {isFirst === false && (
              <ResultContentExit
                setCurrentState={setCurrentState}
                setCurrentQuesNum={setCurrentQuesNum}
              />
            )}
          </div>
        )}
        {currentState === "question" && (
          <div className="relative w-full">
            <QuestionContent
              currentQuesNum={currentQuesNum}
              question={questions[currentQuesNum]}
              setCurrentQuesNum={setCurrentQuesNum}
              setCurrentState={setCurrentState}
            />
            {currentQuesNum > 0 ? (
              <QuestionContentExit
                currentQuesNum={currentQuesNum - 1}
                question={questions[currentQuesNum - 1]}
                setCurrentQuesNum={setCurrentQuesNum}
                setCurrentState={setCurrentState}
              />
            ) : (
              <WelcomeContentExit setCurrentState={setCurrentState} />
            )}
          </div>
        )}
        {currentState === "result" && (
          <div className="relative w-full">
            <ResultContent
              setCurrentState={setCurrentState}
              setCurrentQuesNum={setCurrentQuesNum}
            />
            <QuestionContentExit
              currentQuesNum={currentQuesNum - 1}
              question={questions[currentQuesNum - 1]}
              setCurrentQuesNum={setCurrentQuesNum}
              setCurrentState={setCurrentState}
            />
          </div>
        )}
      </AnimatePresence>
    </div>
  );
};
